
import { configureStore } from "@reduxjs/toolkit"
import { protectedApi } from "./Api/protectedAPI"
import { publicApi } from "./Api/publicAPI"

import { hideSideBar } from "./Slices/sidebar-hide"
import { getSelectedIds } from "./Slices/selectedDeviceIds"
import {getDashboardSelectedIds} from "./Slices/dashboardDeviceIds"


// Add the baseApi reducer to your store
export const store: any = configureStore({
    reducer: {
        [protectedApi.reducerPath]: protectedApi.reducer,
        [publicApi.reducerPath]: publicApi.reducer,

        [hideSideBar.name]: hideSideBar.reducer,
        [getSelectedIds.name]: getSelectedIds.reducer,
        [getDashboardSelectedIds.name]: getDashboardSelectedIds.reducer,

    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(protectedApi.middleware, publicApi.middleware),
})

// Export types for dispatch and state
export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
